


















import { CollectionItem } from '@/resource/collection-item/collection-item.model';
import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import QuestionInfo from '../question/QuestionInfo.vue';

@Component({
  components: { QuestionInfo },
})
export default class PaperItemOption extends Vue {
  @Prop({ required: true })
  paperItem: CollectionItem;

  @Inject('deleteQuestionClicked')
  deleteQuestionClicked!: (questionId: number) => void;

  @Inject('addOrEditQuestion')
  addOrEditQuestion!: (
    isSubjective: boolean,
    paperItemId: number,
    questionId: number,
  ) => Promise<void>;

  get question() {
    return (
      this.paperItem.questionObjective || this.paperItem.questionSubjective
    );
  }

  editQuestionClicked() {
    this.$sendMpEvent({ event: this.$mp_value.QuestionEditClick });
    this.addOrEditQuestion(
      this.paperItem.questionSubjective ? true : false,
      this.paperItem.id,
      this.paperItem.questionObjective
        ? this.paperItem.questionObjective.id
        : this.paperItem.questionSubjective
        ? this.paperItem.questionSubjective.id
        : 0,
    );
  }
}
